module.exports = __webpack_public_path__ + "img/VNFT LogoMark Green@3x.a38ab66c.png";